<c11n-button [buttonType]="'button'"
             class="buy-button-vfa" [size]="'small'"
             [variant]="'primary'"
             [href]="finalURL"
             [labelText]="'Buy'"
             [ariaLabelText]="'Buy ' + fundInput.longName"
             (clickEvent)="buyButtonClicked($event)"
             disabled='fundInput.fundFact.isClosed || fundInput.fundFact.isClosedToNewInvestors'>
</c11n-button>
